/**
 * Packages
 */
import { Container, Row, Col, Nav, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Subscribe from '../../components/Subscribe';

/**
 * Images
 */
import logo from './logo.svg';

/**
 * Styles
 */
import './index.scss';

/**
 * Footer component
 */
function Footer(props: any) {
  return (
    <footer className={`Footer Footer__${props.isLaunch ? 'launch' : 'prelaunch'}`}>
      <Container>
        <Row className='align-items-center'>
          <Col sm={3}>
            <img
              src={logo}
              className="d-inline-block Footer__logo-img"
              alt="Trendo logo"
            />
          </Col>
          <Col sm={4}>
            <Nav className="flex-column">
              <Nav.Item>
                <Nav.Link as="a" href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}>
                  Contact us
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link>
                  <Link to="/terms">Terms and Conditions</Link>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link>
                  <Link to="/privacy">Privacy Policy</Link>
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col sm={5} className='text-center'>
            <Button className='Footer__button' href={`${process.env.REACT_APP_APPLE_STORE_URL}`} target='_blank'>
              Download now
            </Button>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;